import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import type { CreateQuoteRequest, CreateQuoteResponse } from "./quotesApi";
import { createQuote } from "./quotesApi";

export const useCreateQuote = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const createQuoteMutation = useMutation<CreateQuoteResponse, unknown, CreateQuoteRequest>({
    mutationFn: (request) => createQuote(request),
    onSuccess: async ({ quotes }) => {
      enqueueSnackbar(
        quotes.length === 1
          ? "Zapytanie o wycenę zostało utworzone"
          : `Zapytania o wyceny do ${quotes.length} dostawców zostały utworzone`,
        { variant: "success" },
      );
      await queryClient.invalidateQueries({ queryKey: ["quotes"] });
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się utworzyć wyceny. Powód: ${(error as Error).message}`, {
        variant: "error",
      });
    },
  });

  return {
    createQuote: (request: CreateQuoteRequest) => createQuoteMutation.mutateAsync(request),
    isCreating: createQuoteMutation.isPending,
  };
};
